export const COUNTRIES_DDI = [
  {
    name: 'Afghanistan',
    ddi: '+93',
    code: 'AF',
  },
  {
    name: 'Aland Islands',
    ddi: '+358',
    code: 'AX',
  },
  {
    name: 'Albania',
    ddi: '+355',
    code: 'AL',
  },
  {
    name: 'Algeria',
    ddi: '+213',
    code: 'DZ',
  },
  {
    name: 'AmericanSamoa',
    ddi: '+1684',
    code: 'AS',
  },
  {
    name: 'Andorra',
    ddi: '+376',
    code: 'AD',
  },
  {
    name: 'Angola',
    ddi: '+244',
    code: 'AO',
  },
  {
    name: 'Anguilla',
    ddi: '+1264',
    code: 'AI',
  },
  {
    name: 'Antarctica',
    ddi: '+672',
    code: 'AQ',
  },
  {
    name: 'Antigua and Barbuda',
    ddi: '+1268',
    code: 'AG',
  },
  {
    name: 'Argentina',
    ddi: '+54',
    code: 'AR',
  },
  {
    name: 'Armenia',
    ddi: '+374',
    code: 'AM',
  },
  {
    name: 'Aruba',
    ddi: '+297',
    code: 'AW',
  },
  {
    name: 'Australia',
    ddi: '+61',
    code: 'AU',
  },
  {
    name: 'Austria',
    ddi: '+43',
    code: 'AT',
  },
  {
    name: 'Azerbaijan',
    ddi: '+994',
    code: 'AZ',
  },
  {
    name: 'Bahamas',
    ddi: '+1242',
    code: 'BS',
  },
  {
    name: 'Bahrain',
    ddi: '+973',
    code: 'BH',
  },
  {
    name: 'Bangladesh',
    ddi: '+880',
    code: 'BD',
  },
  {
    name: 'Barbados',
    ddi: '+1246',
    code: 'BB',
  },
  {
    name: 'Belarus',
    ddi: '+375',
    code: 'BY',
  },
  {
    name: 'Belgium',
    ddi: '+32',
    code: 'BE',
  },
  {
    name: 'Belize',
    ddi: '+501',
    code: 'BZ',
  },
  {
    name: 'Benin',
    ddi: '+229',
    code: 'BJ',
  },
  {
    name: 'Bermuda',
    ddi: '+1441',
    code: 'BM',
  },
  {
    name: 'Bhutan',
    ddi: '+975',
    code: 'BT',
  },
  {
    name: 'Bolivia, Plurinational State of',
    ddi: '+591',
    code: 'BO',
  },
  {
    name: 'Bosnia and Herzegovina',
    ddi: '+387',
    code: 'BA',
  },
  {
    name: 'Botswana',
    ddi: '+267',
    code: 'BW',
  },
  {
    name: 'Brasil',
    ddi: '+55',
    code: 'BR',
  },
  {
    name: 'British Indian Ocean Territory',
    ddi: '+246',
    code: 'IO',
  },
  {
    name: 'Brunei Darussalam',
    ddi: '+673',
    code: 'BN',
  },
  {
    name: 'Bulgaria',
    ddi: '+359',
    code: 'BG',
  },
  {
    name: 'Burkina Faso',
    ddi: '+226',
    code: 'BF',
  },
  {
    name: 'Burundi',
    ddi: '+257',
    code: 'BI',
  },
  {
    name: 'Cambodia',
    ddi: '+855',
    code: 'KH',
  },
  {
    name: 'Cameroon',
    ddi: '+237',
    code: 'CM',
  },
  {
    name: 'Canada',
    ddi: '+1',
    code: 'CA',
  },
  {
    name: 'Cape Verde',
    ddi: '+238',
    code: 'CV',
  },
  {
    name: 'Cayman Islands',
    ddi: '+ 345',
    code: 'KY',
  },
  {
    name: 'Central African Republic',
    ddi: '+236',
    code: 'CF',
  },
  {
    name: 'Chad',
    ddi: '+235',
    code: 'TD',
  },
  {
    name: 'Chile',
    ddi: '+56',
    code: 'CL',
  },
  {
    name: 'China',
    ddi: '+86',
    code: 'CN',
  },
  {
    name: 'Christmas Island',
    ddi: '+61',
    code: 'CX',
  },
  {
    name: 'Cocos (Keeling) Islands',
    ddi: '+61',
    code: 'CC',
  },
  {
    name: 'Colombia',
    ddi: '+57',
    code: 'CO',
  },
  {
    name: 'Comoros',
    ddi: '+269',
    code: 'KM',
  },
  {
    name: 'Congo',
    ddi: '+242',
    code: 'CG',
  },
  {
    name: 'Congo, The Democratic Republic of the Congo',
    ddi: '+243',
    code: 'CD',
  },
  {
    name: 'Cook Islands',
    ddi: '+682',
    code: 'CK',
  },
  {
    name: 'Costa Rica',
    ddi: '+506',
    code: 'CR',
  },
  {
    name: "Cote d'Ivoire",
    ddi: '+225',
    code: 'CI',
  },
  {
    name: 'Croatia',
    ddi: '+385',
    code: 'HR',
  },
  {
    name: 'Cuba',
    ddi: '+53',
    code: 'CU',
  },
  {
    name: 'Cyprus',
    ddi: '+357',
    code: 'CY',
  },
  {
    name: 'Czech Republic',
    ddi: '+420',
    code: 'CZ',
  },
  {
    name: 'Denmark',
    ddi: '+45',
    code: 'DK',
  },
  {
    name: 'Djibouti',
    ddi: '+253',
    code: 'DJ',
  },
  {
    name: 'Dominica',
    ddi: '+1767',
    code: 'DM',
  },
  {
    name: 'Dominican Republic',
    ddi: '+1849',
    code: 'DO',
  },
  {
    name: 'Ecuador',
    ddi: '+593',
    code: 'EC',
  },
  {
    name: 'Egypt',
    ddi: '+20',
    code: 'EG',
  },
  {
    name: 'El Salvador',
    ddi: '+503',
    code: 'SV',
  },
  {
    name: 'Equatorial Guinea',
    ddi: '+240',
    code: 'GQ',
  },
  {
    name: 'Eritrea',
    ddi: '+291',
    code: 'ER',
  },
  {
    name: 'Estonia',
    ddi: '+372',
    code: 'EE',
  },
  {
    name: 'Ethiopia',
    ddi: '+251',
    code: 'ET',
  },
  {
    name: 'Falkland Islands (Malvinas)',
    ddi: '+500',
    code: 'FK',
  },
  {
    name: 'Faroe Islands',
    ddi: '+298',
    code: 'FO',
  },
  {
    name: 'Fiji',
    ddi: '+679',
    code: 'FJ',
  },
  {
    name: 'Finland',
    ddi: '+358',
    code: 'FI',
  },
  {
    name: 'France',
    ddi: '+33',
    code: 'FR',
  },
  {
    name: 'French Guiana',
    ddi: '+594',
    code: 'GF',
  },
  {
    name: 'French Polynesia',
    ddi: '+689',
    code: 'PF',
  },
  {
    name: 'Gabon',
    ddi: '+241',
    code: 'GA',
  },
  {
    name: 'Gambia',
    ddi: '+220',
    code: 'GM',
  },
  {
    name: 'Georgia',
    ddi: '+995',
    code: 'GE',
  },
  {
    name: 'Germany',
    ddi: '+49',
    code: 'DE',
  },
  {
    name: 'Ghana',
    ddi: '+233',
    code: 'GH',
  },
  {
    name: 'Gibraltar',
    ddi: '+350',
    code: 'GI',
  },
  {
    name: 'Greece',
    ddi: '+30',
    code: 'GR',
  },
  {
    name: 'Greenland',
    ddi: '+299',
    code: 'GL',
  },
  {
    name: 'Grenada',
    ddi: '+1473',
    code: 'GD',
  },
  {
    name: 'Guadeloupe',
    ddi: '+590',
    code: 'GP',
  },
  {
    name: 'Guam',
    ddi: '+1671',
    code: 'GU',
  },
  {
    name: 'Guatemala',
    ddi: '+502',
    code: 'GT',
  },
  {
    name: 'Guernsey',
    ddi: '+44',
    code: 'GG',
  },
  {
    name: 'Guinea',
    ddi: '+224',
    code: 'GN',
  },
  {
    name: 'Guinea-Bissau',
    ddi: '+245',
    code: 'GW',
  },
  {
    name: 'Guyana',
    ddi: '+595',
    code: 'GY',
  },
  {
    name: 'Haiti',
    ddi: '+509',
    code: 'HT',
  },
  {
    name: 'Holy See (Vatican City State)',
    ddi: '+379',
    code: 'VA',
  },
  {
    name: 'Honduras',
    ddi: '+504',
    code: 'HN',
  },
  {
    name: 'Hong Kong',
    ddi: '+852',
    code: 'HK',
  },
  {
    name: 'Hungary',
    ddi: '+36',
    code: 'HU',
  },
  {
    name: 'Iceland',
    ddi: '+354',
    code: 'IS',
  },
  {
    name: 'India',
    ddi: '+91',
    code: 'IN',
  },
  {
    name: 'Indonesia',
    ddi: '+62',
    code: 'ID',
  },
  {
    name: 'Iran, Islamic Republic of Persian Gulf',
    ddi: '+98',
    code: 'IR',
  },
  {
    name: 'Iraq',
    ddi: '+964',
    code: 'IQ',
  },
  {
    name: 'Ireland',
    ddi: '+353',
    code: 'IE',
  },
  {
    name: 'Isle of Man',
    ddi: '+44',
    code: 'IM',
  },
  {
    name: 'Israel',
    ddi: '+972',
    code: 'IL',
  },
  {
    name: 'Italy',
    ddi: '+39',
    code: 'IT',
  },
  {
    name: 'Jamaica',
    ddi: '+1876',
    code: 'JM',
  },
  {
    name: 'Japan',
    ddi: '+81',
    code: 'JP',
  },
  {
    name: 'Jersey',
    ddi: '+44',
    code: 'JE',
  },
  {
    name: 'Jordan',
    ddi: '+962',
    code: 'JO',
  },
  {
    name: 'Kazakhstan',
    ddi: '+77',
    code: 'KZ',
  },
  {
    name: 'Kenya',
    ddi: '+254',
    code: 'KE',
  },
  {
    name: 'Kiribati',
    ddi: '+686',
    code: 'KI',
  },
  {
    name: "Korea, Democratic People's Republic of Korea",
    ddi: '+850',
    code: 'KP',
  },
  {
    name: 'Korea, Republic of South Korea',
    ddi: '+82',
    code: 'KR',
  },
  {
    name: 'Kuwait',
    ddi: '+965',
    code: 'KW',
  },
  {
    name: 'Kyrgyzstan',
    ddi: '+996',
    code: 'KG',
  },
  {
    name: 'Laos',
    ddi: '+856',
    code: 'LA',
  },
  {
    name: 'Latvia',
    ddi: '+371',
    code: 'LV',
  },
  {
    name: 'Lebanon',
    ddi: '+961',
    code: 'LB',
  },
  {
    name: 'Lesotho',
    ddi: '+266',
    code: 'LS',
  },
  {
    name: 'Liberia',
    ddi: '+231',
    code: 'LR',
  },
  {
    name: 'Libyan Arab Jamahiriya',
    ddi: '+218',
    code: 'LY',
  },
  {
    name: 'Liechtenstein',
    ddi: '+423',
    code: 'LI',
  },
  {
    name: 'Lithuania',
    ddi: '+370',
    code: 'LT',
  },
  {
    name: 'Luxembourg',
    ddi: '+352',
    code: 'LU',
  },
  {
    name: 'Macao',
    ddi: '+853',
    code: 'MO',
  },
  {
    name: 'Macedonia',
    ddi: '+389',
    code: 'MK',
  },
  {
    name: 'Madagascar',
    ddi: '+261',
    code: 'MG',
  },
  {
    name: 'Malawi',
    ddi: '+265',
    code: 'MW',
  },
  {
    name: 'Malaysia',
    ddi: '+60',
    code: 'MY',
  },
  {
    name: 'Maldives',
    ddi: '+960',
    code: 'MV',
  },
  {
    name: 'Mali',
    ddi: '+223',
    code: 'ML',
  },
  {
    name: 'Malta',
    ddi: '+356',
    code: 'MT',
  },
  {
    name: 'Marshall Islands',
    ddi: '+692',
    code: 'MH',
  },
  {
    name: 'Martinique',
    ddi: '+596',
    code: 'MQ',
  },
  {
    name: 'Mauritania',
    ddi: '+222',
    code: 'MR',
  },
  {
    name: 'Mauritius',
    ddi: '+230',
    code: 'MU',
  },
  {
    name: 'Mayotte',
    ddi: '+262',
    code: 'YT',
  },
  {
    name: 'Mexico',
    ddi: '+52',
    code: 'MX',
  },
  {
    name: 'Micronesia, Federated States of Micronesia',
    ddi: '+691',
    code: 'FM',
  },
  {
    name: 'Moldova',
    ddi: '+373',
    code: 'MD',
  },
  {
    name: 'Monaco',
    ddi: '+377',
    code: 'MC',
  },
  {
    name: 'Mongolia',
    ddi: '+976',
    code: 'MN',
  },
  {
    name: 'Montenegro',
    ddi: '+382',
    code: 'ME',
  },
  {
    name: 'Montserrat',
    ddi: '+1664',
    code: 'MS',
  },
  {
    name: 'Morocco',
    ddi: '+212',
    code: 'MA',
  },
  {
    name: 'Mozambique',
    ddi: '+258',
    code: 'MZ',
  },
  {
    name: 'Myanmar',
    ddi: '+95',
    code: 'MM',
  },
  {
    name: 'Namibia',
    ddi: '+264',
    code: 'NA',
  },
  {
    name: 'Nauru',
    ddi: '+674',
    code: 'NR',
  },
  {
    name: 'Nepal',
    ddi: '+977',
    code: 'NP',
  },
  {
    name: 'Netherlands',
    ddi: '+31',
    code: 'NL',
  },
  {
    name: 'Netherlands Antilles',
    ddi: '+599',
    code: 'AN',
  },
  {
    name: 'New Caledonia',
    ddi: '+687',
    code: 'NC',
  },
  {
    name: 'New Zealand',
    ddi: '+64',
    code: 'NZ',
  },
  {
    name: 'Nicaragua',
    ddi: '+505',
    code: 'NI',
  },
  {
    name: 'Niger',
    ddi: '+227',
    code: 'NE',
  },
  {
    name: 'Nigeria',
    ddi: '+234',
    code: 'NG',
  },
  {
    name: 'Niue',
    ddi: '+683',
    code: 'NU',
  },
  {
    name: 'Norfolk Island',
    ddi: '+672',
    code: 'NF',
  },
  {
    name: 'Northern Mariana Islands',
    ddi: '+1670',
    code: 'MP',
  },
  {
    name: 'Norway',
    ddi: '+47',
    code: 'NO',
  },
  {
    name: 'Oman',
    ddi: '+968',
    code: 'OM',
  },
  {
    name: 'Pakistan',
    ddi: '+92',
    code: 'PK',
  },
  {
    name: 'Palau',
    ddi: '+680',
    code: 'PW',
  },
  {
    name: 'Palestinian Territory, Occupied',
    ddi: '+970',
    code: 'PS',
  },
  {
    name: 'Panama',
    ddi: '+507',
    code: 'PA',
  },
  {
    name: 'Papua New Guinea',
    ddi: '+675',
    code: 'PG',
  },
  {
    name: 'Paraguay',
    ddi: '+595',
    code: 'PY',
  },
  {
    name: 'Peru',
    ddi: '+51',
    code: 'PE',
  },
  {
    name: 'Philippines',
    ddi: '+63',
    code: 'PH',
  },
  {
    name: 'Pitcairn',
    ddi: '+872',
    code: 'PN',
  },
  {
    name: 'Poland',
    ddi: '+48',
    code: 'PL',
  },
  {
    name: 'Portugal',
    ddi: '+351',
    code: 'PT',
  },
  {
    name: 'Puerto Rico',
    ddi: '+1939',
    code: 'PR',
  },
  {
    name: 'Qatar',
    ddi: '+974',
    code: 'QA',
  },
  {
    name: 'Romania',
    ddi: '+40',
    code: 'RO',
  },
  {
    name: 'Russia',
    ddi: '+7',
    code: 'RU',
  },
  {
    name: 'Rwanda',
    ddi: '+250',
    code: 'RW',
  },
  {
    name: 'Reunion',
    ddi: '+262',
    code: 'RE',
  },
  {
    name: 'Saint Barthelemy',
    ddi: '+590',
    code: 'BL',
  },
  {
    name: 'Saint Helena, Ascension and Tristan Da Cunha',
    ddi: '+290',
    code: 'SH',
  },
  {
    name: 'Saint Kitts and Nevis',
    ddi: '+1869',
    code: 'KN',
  },
  {
    name: 'Saint Lucia',
    ddi: '+1758',
    code: 'LC',
  },
  {
    name: 'Saint Martin',
    ddi: '+590',
    code: 'MF',
  },
  {
    name: 'Saint Pierre and Miquelon',
    ddi: '+508',
    code: 'PM',
  },
  {
    name: 'Saint Vincent and the Grenadines',
    ddi: '+1784',
    code: 'VC',
  },
  {
    name: 'Samoa',
    ddi: '+685',
    code: 'WS',
  },
  {
    name: 'San Marino',
    ddi: '+378',
    code: 'SM',
  },
  {
    name: 'Sao Tome and Principe',
    ddi: '+239',
    code: 'ST',
  },
  {
    name: 'Saudi Arabia',
    ddi: '+966',
    code: 'SA',
  },
  {
    name: 'Senegal',
    ddi: '+221',
    code: 'SN',
  },
  {
    name: 'Serbia',
    ddi: '+381',
    code: 'RS',
  },
  {
    name: 'Seychelles',
    ddi: '+248',
    code: 'SC',
  },
  {
    name: 'Sierra Leone',
    ddi: '+232',
    code: 'SL',
  },
  {
    name: 'Singapore',
    ddi: '+65',
    code: 'SG',
  },
  {
    name: 'Slovakia',
    ddi: '+421',
    code: 'SK',
  },
  {
    name: 'Slovenia',
    ddi: '+386',
    code: 'SI',
  },
  {
    name: 'Solomon Islands',
    ddi: '+677',
    code: 'SB',
  },
  {
    name: 'Somalia',
    ddi: '+252',
    code: 'SO',
  },
  {
    name: 'South Africa',
    ddi: '+27',
    code: 'ZA',
  },
  {
    name: 'South Sudan',
    ddi: '+211',
    code: 'SS',
  },
  {
    name: 'South Georgia and the South Sandwich Islands',
    ddi: '+500',
    code: 'GS',
  },
  {
    name: 'Spain',
    ddi: '+34',
    code: 'ES',
  },
  {
    name: 'Sri Lanka',
    ddi: '+94',
    code: 'LK',
  },
  {
    name: 'Sudan',
    ddi: '+249',
    code: 'SD',
  },
  {
    name: 'Suriname',
    ddi: '+597',
    code: 'SR',
  },
  {
    name: 'Svalbard and Jan Mayen',
    ddi: '+47',
    code: 'SJ',
  },
  {
    name: 'Swaziland',
    ddi: '+268',
    code: 'SZ',
  },
  {
    name: 'Sweden',
    ddi: '+46',
    code: 'SE',
  },
  {
    name: 'Switzerland',
    ddi: '+41',
    code: 'CH',
  },
  {
    name: 'Syrian Arab Republic',
    ddi: '+963',
    code: 'SY',
  },
  {
    name: 'Taiwan',
    ddi: '+886',
    code: 'TW',
  },
  {
    name: 'Tajikistan',
    ddi: '+992',
    code: 'TJ',
  },
  {
    name: 'Tanzania, United Republic of Tanzania',
    ddi: '+255',
    code: 'TZ',
  },
  {
    name: 'Thailand',
    ddi: '+66',
    code: 'TH',
  },
  {
    name: 'Timor-Leste',
    ddi: '+670',
    code: 'TL',
  },
  {
    name: 'Togo',
    ddi: '+228',
    code: 'TG',
  },
  {
    name: 'Tokelau',
    ddi: '+690',
    code: 'TK',
  },
  {
    name: 'Tonga',
    ddi: '+676',
    code: 'TO',
  },
  {
    name: 'Trinidad and Tobago',
    ddi: '+1868',
    code: 'TT',
  },
  {
    name: 'Tunisia',
    ddi: '+216',
    code: 'TN',
  },
  {
    name: 'Turkey',
    ddi: '+90',
    code: 'TR',
  },
  {
    name: 'Turkmenistan',
    ddi: '+993',
    code: 'TM',
  },
  {
    name: 'Turks and Caicos Islands',
    ddi: '+1649',
    code: 'TC',
  },
  {
    name: 'Tuvalu',
    ddi: '+688',
    code: 'TV',
  },
  {
    name: 'Uganda',
    ddi: '+256',
    code: 'UG',
  },
  {
    name: 'Ukraine',
    ddi: '+380',
    code: 'UA',
  },
  {
    name: 'United Arab Emirates',
    ddi: '+971',
    code: 'AE',
  },
  {
    name: 'United Kingdom',
    ddi: '+44',
    code: 'GB',
  },
  {
    name: 'United States',
    ddi: '+1',
    code: 'US',
  },
  {
    name: 'Uruguay',
    ddi: '+598',
    code: 'UY',
  },
  {
    name: 'Uzbekistan',
    ddi: '+998',
    code: 'UZ',
  },
  {
    name: 'Vanuatu',
    ddi: '+678',
    code: 'VU',
  },
  {
    name: 'Venezuela, Bolivarian Republic of Venezuela',
    ddi: '+58',
    code: 'VE',
  },
  {
    name: 'Vietnam',
    ddi: '+84',
    code: 'VN',
  },
  {
    name: 'Virgin Islands, British',
    ddi: '+1284',
    code: 'VG',
  },
  {
    name: 'Virgin Islands, U.S.',
    ddi: '+1340',
    code: 'VI',
  },
  {
    name: 'Wallis and Futuna',
    ddi: '+681',
    code: 'WF',
  },
  {
    name: 'Yemen',
    ddi: '+967',
    code: 'YE',
  },
  {
    name: 'Zambia',
    ddi: '+260',
    code: 'ZM',
  },
  {
    name: 'Zimbabwe',
    ddi: '+263',
    code: 'ZW',
  },
]
